

window['baseUrl']=':3000/';// /
window['baseUrl']='/';

window['apiUrl']='https://paycrossbank.com' 

window['basename']='/wp-user';
//window['basename']='';//'/wp-user';



//

//window['login']='signin';
window['login']='login';


/*


"homepage":"https://fundflex-financo.online/wp-user",


*/

//export const wpUser=`http://localhost:3000`;
export const wpUser=`https://paycrossbank.com/wp-user`;
export const baseUrl=`https://paycrossbank.com`;

export const production=true;
//export const wpUser=`/wp-user`;


//. //${window.location.hostname}